<div class="corridor-padding">
    <svg width="960" height="500" id="svg8">
        <!-- <defs>
            <linearGradient id="myGradient" gradientTransform="rotate(90)">
              <stop offset="15%"  stop-color="#00e487" />
              <stop offset="65%" stop-color="#1ecbd0" />
            </linearGradient>
          </defs> -->
    </svg>
    </div>

   
